import { useCallback, useState } from 'react'

const isPhoneField = fieldId => fieldId === 'mobilePhone' || fieldId === 'phoneNumber'
// Keep draft only while SPA runtime is alive.
let phoneDraft = ''

export const useAuthPhoneDraft = (initialFieldId = 'mobilePhone') => {
  const [formValues, setFormValues] = useState(() =>
    phoneDraft ? { [initialFieldId]: phoneDraft } : {},
  )

  const handleFieldChange = useCallback((fieldId, event) => {
    if (!isPhoneField(fieldId)) return

    const nextValue = event?.target?.value || ''
    phoneDraft = nextValue
    setFormValues(prevState => ({
      ...prevState,
      [fieldId]: nextValue,
    }))
  }, [])

  return {
    formValues,
    handleFieldChange,
  }
}
